/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../../__generated__/zeus/types';

import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
/** Password reset token to validate. */
export type PasswordResetTokenValidationInput = {
  /** Password reset token whose current validity should be checked. */
  resetPasswordToken: Types.Scalars['NonEmptyString']['input'];
};

/** New password and token used to reset an account password. */
export type ResetPasswordWithTokenInput = {
  /** Replacement password for the account. */
  newPassword: Types.Scalars['NonEmptyString']['input'];
  /** Password reset token authorizing the change. */
  resetPasswordToken: Types.Scalars['NonEmptyString']['input'];
};

export type ViewerSessionQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerSessionQuery = { viewer: { session: { isImpersonated: Types.Scalars['Boolean']['output'], profile: { customerId: Types.Scalars['UUID']['output'] | null, email: Types.Scalars['EmailAddress']['output'] | null, firstName: Types.Scalars['String']['output'] | null, fullName: Types.Scalars['String']['output'] | null, primaryPhoneNumberText: Types.Scalars['String']['output'] | null } | null } | null } };

export type PasswordResetTokenValidationQueryVariables = Exact<{
  input: Types.PasswordResetTokenValidationInput;
}>;


export type PasswordResetTokenValidationQuery = { account: { passwordResetTokenValidation:
      | { __typename: 'InvalidInputError' }
      | { __typename: 'NotFoundError' }
      | { __typename: 'PasswordResetTokenValidationPayload', valid: Types.Scalars['Boolean']['output'] }
      | { __typename: 'UnauthorizedError' }
     } };

export type ResetPasswordWithTokenMutationVariables = Exact<{
  input: Types.ResetPasswordWithTokenInput;
}>;


export type ResetPasswordWithTokenMutation = { resetPasswordWithToken:
    | { __typename: 'CommandResult', success: Types.Scalars['Boolean']['output'] }
    | { __typename: 'InvalidInputError' }
    | { __typename: 'NotFoundError' }
    | { __typename: 'UnauthorizedError' }
   };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const ViewerSessionDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ViewerSession {
  viewer {
    session {
      isImpersonated
      profile {
        customerId
        email
        firstName
        fullName
        primaryPhoneNumberText
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ViewerSessionQuery, ViewerSessionQueryVariables>;
export const PasswordResetTokenValidationDocument = /*#__PURE__*/ new TypedDocumentString(`
    query PasswordResetTokenValidation($input: PasswordResetTokenValidationInput!) {
  account {
    passwordResetTokenValidation(input: $input) {
      __typename
      ... on PasswordResetTokenValidationPayload {
        valid
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PasswordResetTokenValidationQuery, PasswordResetTokenValidationQueryVariables>;
export const ResetPasswordWithTokenDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation ResetPasswordWithToken($input: ResetPasswordWithTokenInput!) {
  resetPasswordWithToken(input: $input) {
    __typename
    ... on CommandResult {
      success
    }
  }
}
    `) as unknown as TypedDocumentString<ResetPasswordWithTokenMutation, ResetPasswordWithTokenMutationVariables>;